/**
 * @vuepress
 * ---
 * title: Customer Units
 * ---
 */

import Transformer from '../transformer'
import assetURL from '@/utils/assetURL'

/**
 * @class MinialCustomerTransformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */

class MinimalCustomerTransformer extends Transformer {
  static fetch({
    id,
    codename,
    logo,
    name
  }) {
    return {
      id,
      codename,
      logo: logo ? assetURL(logo) : null,
      name
    }
  }
}

export default MinimalCustomerTransformer
